import { render, staticRenderFns } from "./SupergroupList.vue?vue&type=template&id=3c77aeea&scoped=true"
import script from "./SupergroupList.vue?vue&type=script&lang=js"
export * from "./SupergroupList.vue?vue&type=script&lang=js"
import style0 from "./SupergroupList.vue?vue&type=style&index=0&id=3c77aeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77aeea",
  null
  
)

export default component.exports